import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Phone, Home, ArrowRight } from 'lucide-react';
import { Layout } from '../components/layout/Layout';
import { SEO } from '../components/shared/SEO';
import { COMPANY_INFO, SERVICES } from '../data/mock';

export default function NotFoundPage() {
  // Set a real 404 status hint for crawlers that read the meta tag.
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'prerender-status-code';
    meta.content = '404';
    document.head.appendChild(meta);
    return () => meta.remove();
  }, []);

  return (
    <Layout>
      <SEO
        title="Page Not Found | AAA Irrigation Service"
        description="The page you were looking for could not be found. Browse our sprinkler repair and irrigation services in Allen, TX or call (469) 751-3567."
        canonical="https://aaairrigationservice.com/"
      />
      <section className="bg-[#0f172a] min-h-[60vh] flex items-center py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <p className="text-[#1b7abf] font-black text-7xl md:text-8xl tracking-tight mb-4">404</p>
          <h1 className="text-3xl md:text-5xl font-black italic uppercase mb-4">
            Page Not Found
          </h1>
          <p className="text-slate-300 text-lg mb-8 max-w-xl mx-auto">
            The page you are looking for moved or never existed. Need help with sprinkler repair in
            Allen, Plano, McKinney, or Frisco? Call us or browse our services below.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center mb-12">
            <a
              href={`tel:${COMPANY_INFO.phone}`}
              className="inline-flex items-center justify-center gap-2 bg-[#ea580c] hover:bg-[#c2410c] text-white font-black px-8 py-4 rounded-2xl uppercase tracking-wide"
            >
              <Phone className="w-5 h-5" />
              Call {COMPANY_INFO.phoneFormatted}
            </a>
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 border border-white/40 text-white font-bold px-8 py-4 rounded-2xl"
            >
              <Home className="w-5 h-5" />
              Back to Home
            </Link>
          </div>
          <div className="text-left bg-white/5 border border-white/10 rounded-2xl p-6">
            <p className="text-xs font-black uppercase tracking-widest text-[#1b7abf] mb-3">
              Popular Services
            </p>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2">
              {SERVICES.slice(0, 8).map(s => (
                <li key={s.id}>
                  <Link
                    to={`/services/${s.id}`}
                    className="inline-flex items-center gap-2 text-slate-300 hover:text-[#1b7abf] text-sm"
                  >
                    <ArrowRight className="w-3 h-3" />
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </Layout>
  );
}
